import PropTypes from "prop-types"
import { People } from "@mui/icons-material"
import { connect } from "react-redux"
import { get } from "lodash"
import Header from "modules/home-header"

function TokenResourcesHeader({ name, account }) {
  return <Header Icon={People} title={`Token Permissions:  ${name}`} account={account} />
}

TokenResourcesHeader.propTypes = {
  account: PropTypes.string.isRequired,
  name: PropTypes.string,
}

export default connect(state => ({ name: get(state, "global.data.tokenPermissions.data.token.name") }), null)(TokenResourcesHeader)
